/**
 * Shared product-number helpers for the static catalogue.
 * Used by CRA (via import) and by scripts/generate-catalog.mjs (via createRequire).
 */

function normalizeProductNumber(productNumber) {
  if (productNumber == null || productNumber === "") return "";
  return String(productNumber)
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
}

/**
 * Lookup shard filename stem (without .json) from a normalized part number.
 * Safe names: lowercase letters, digits, underscore only.
 */
function getPartNumberLookupShard(normalized) {
  if (!normalized || normalized.length < 2) return "__";
  const prefix = normalized.slice(0, 2).toLowerCase();
  if (!/^[a-z0-9]{2}$/.test(prefix)) return "__";
  return prefix;
}

/**
 * Detail shard filename stem from product UUID (final two hex chars).
 */
function getProductIdShard(productId) {
  const hex = String(productId || "")
    .replace(/-/g, "")
    .toLowerCase();
  if (hex.length < 2) return "00";
  const suffix = hex.slice(-2);
  return /^[0-9a-f]{2}$/.test(suffix) ? suffix : "00";
}

/**
 * Normalizes a product title for search: uppercase, diacritic-stripped,
 * punctuation removed, whitespace collapsed. Keeps meaningful letters/digits
 * and single spaces. Unicode-safe (never throws on odd input).
 */
function normalizeSearchTitle(title) {
  if (title == null) return "";
  let value = String(title);
  try {
    value = value.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
  } catch {
    // Ignore normalization errors and continue with the raw string.
  }
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9 ]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Title search shard stem: first two alphanumeric characters of the
 * normalized title (lowercased). One-character fallback for short titles,
 * "__" for empty/invalid titles. Supports numeric-leading titles.
 */
function getTitleSearchShard(normalizedTitle) {
  const alnum = String(normalizedTitle || "")
    .replace(/[^A-Za-z0-9]/g, "")
    .toLowerCase();
  if (alnum.length >= 2) {
    const prefix = alnum.slice(0, 2);
    return /^[a-z0-9]{2}$/.test(prefix) ? prefix : "__";
  }
  if (alnum.length === 1) {
    return /^[a-z0-9]$/.test(alnum) ? alnum : "__";
  }
  return "__";
}

module.exports = {
  normalizeProductNumber,
  getPartNumberLookupShard,
  getProductIdShard,
  normalizeSearchTitle,
  getTitleSearchShard,
};
